module.exports = __webpack_public_path__ + "./images/053764331bf0e2b6e07adb27fa450a4d.webp";